"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = Image;
var react_1 = __importDefault(require("react"));
var FileboyProvider_1 = require("../FileboyProvider");
var FileIcon_1 = require("./FileIcon");
function Image(_a) {
    var id = _a.id, label = _a.label, className = _a.className, onError = _a.onError, namespace = _a.namespace, onLoad = _a.onLoad, imgProps = _a.imgProps, options = __rest(_a, ["id", "label", "className", "onError", "namespace", "onLoad", "imgProps"]);
    var buildImageUrl = (0, FileboyProvider_1.useFileboy)(namespace).buildImageUrl;
    if (!id && !label) {
        console.error("Image must be passed either a label or an id.");
        return react_1.default.createElement(FileIcon_1.FileIcon, { error: true });
    }
    var url = buildImageUrl((id || label), options);
    return react_1.default.createElement("img", __assign({}, imgProps, { src: url, className: className, onError: onError, onLoad: onLoad }));
}
